import { useTranslation } from 'react-i18next';
import { Box, MaterialSymbol, withStyles } from 'vopay';
import { Title } from '#shared/components/UI';
import CollapsibleList from './CollapsibleList/CollapsibleList';
import PermissionContainer from './PermissionContainer/PermissionContainer';
import { usePermissionsContext } from './PermissionsContext';
import styles from './PermissionsSections.module.scss';

const cn = withStyles(styles);

/** `Permissions.Sections`: the form and its section tree, or the not-found state when a search matches nothing. */
export default function PermissionsSections() {
  const { editor, formID } = usePermissionsContext();
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Permissions' });

  return (
    <form onSubmit={editor.ctx.handleSubmit} id={formID} className={cn('formContainer')}>
      {editor.isFiltering && !editor.hasResults ? (
        <div className={cn('emptyStateWrapper')}>
          <Box flx="col" ai="center" jc="center" gap="sm">
            <MaterialSymbol icon="manage_search" size="90px" color="rgba(45, 45, 45, 0.2)" />
            <Title level="4">{t('notFound', { defaultValue: 'Permission Not Found' })}</Title>
          </Box>
        </div>
      ) : (
        <CollapsibleList className={cn('outerList')}>
          {editor.visibleSections.map((section) => (
            <PermissionContainer key={section.id} section={section} depth={0} />
          ))}
        </CollapsibleList>
      )}
    </form>
  );
}
